export default __webpack_public_path__ + "static/media/fa-solid-900.dc4cd499.eot";